import React from "react";
import ReactDOM from "react-dom/client";
import { MotionConfig } from "framer-motion";

import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { SiteProvider } from "./SiteContext";

import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <SiteProvider>
            {/* Honor the OS "reduce motion" setting for framer animations */}
            <MotionConfig reducedMotion="user">
                <App />
            </MotionConfig>
        </SiteProvider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
